export default __webpack_public_path__ + "media/images/client-logos/conveyancing-abb5c179855293f7afa695a782b70f7f.png";